import "./Login.scss";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button, CircularProgress, TextField } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import LoginIcon from "@mui/icons-material/Login";
import { useDispatch, useSelector } from "react-redux";
import { login } from "../../redux/authSlice";

const Login = () => {
  // Variables
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [credentials, setCredentials] = useState({ email: "", password: "" });
  const { isLoading, isAuthenticated } = useSelector((state) => state.auth);
  const [formError, setFormError] = useState("");

  // Check if already authenticated
  useEffect(() => {
    if (isAuthenticated) {
      navigate("/");
    }
  }, [isAuthenticated, navigate]);

  // Form validation
  const validateForm = () => {
    if (!credentials.email) {
      setFormError("Email is required");
      return false;
    }

    if (!credentials.password) {
      setFormError("Password is required");
      return false;
    }

    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(credentials.email)) {
      setFormError("Please enter a valid email address");
      return false;
    }

    setFormError("");
    return true;
  };

  // Handle Functions
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleChange = (e) => {
    setCredentials((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));

    // Clear error when user starts typing
    if (formError) {
      setFormError("");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validateForm()) {
      dispatch(login(credentials));
    }
  };

  return (
    <div className="login">
      <div className="right"></div>
      <div className="left">
        <form action="" onSubmit={handleSubmit}>
          <TextField
            type="email"
            id="outlined-basic"
            variant="outlined"
            sx={{ width: "80%" }}
            required
            name="email"
            placeholder="الايميل"
            onChange={handleChange}
            value={credentials.email}
            error={Boolean(formError && formError.includes("email"))}
            disabled={isLoading}
          />

          <FormControl sx={{ width: "80%" }} variant="outlined">
            <OutlinedInput
              id="outlined-adornment-password"
              type={showPassword ? "text" : "password"}
              required
              name="password"
              placeholder="كلمة المرور"
              onChange={handleChange}
              value={credentials.password}
              error={Boolean(formError && formError.includes("password"))}
              disabled={isLoading}
              endAdornment={
                credentials.password.length > 0 && (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                      disabled={isLoading}
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                )
              }
            />
          </FormControl>

          <Button
            type="submit"
            variant="contained"
            startIcon={
              isLoading ? (
                <CircularProgress
                  className="circular-progress"
                  size={24}
                  color="inherit"
                />
              ) : (
                <LoginIcon />
              )
            }
            sx={{ gap: "10px", minWidth: "160px" }}
            disabled={isLoading}
          >
            {isLoading ? "جاري التحميل..." : "تسجيل الدخول"}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default Login;
